import { render, staticRenderFns } from "./MsgDetails.vue?vue&type=template&id=1f81646b&scoped=true"
import script from "./MsgDetails.vue?vue&type=script&lang=js"
export * from "./MsgDetails.vue?vue&type=script&lang=js"
import style0 from "./MsgDetails.vue?vue&type=style&index=0&id=1f81646b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f81646b",
  null
  
)

export default component.exports